module.exports = {
    GET_USER_PROFILE_REQUEST: "app/GET_USER_PROFILE_REQUEST",
    UPDATE_USER_PROFILE_REQUEST: "app/UPDATE_USER_PROFILE_REQUEST",
}